import { IPropsEmployeePage } from '../Employee';
import { IBusinessView } from '../../../shared/services';
import { OrderTickets } from '../../../shared/components/SconApp/orderTickets/OrderTickets';

interface IProps extends IPropsEmployeePage {
  business?: IBusinessView;
}

export const EmployeeOrderTickets: React.FC<IProps> = ({ business, selectedBizEmp }) => (
  <OrderTickets business={business} businessEmployee={selectedBizEmp} />
);
